"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribe = exports.post = void 0;
const eventBusState = {};
const getInitialTopicState = () => ({
    payload: undefined,
    observers: [],
});
const post = (topic, payload) => {
    eventBusState[topic] = eventBusState[topic] || getInitialTopicState();
    eventBusState[topic].payload = payload;
    eventBusState[topic].observers.forEach((observer) => {
        if (!observer.predicate || observer.predicate(payload) === true) {
            observer.callback(payload);
        }
    });
};
exports.post = post;
const subscribe = (topic, callback, predicate, options) => {
    eventBusState[topic] = eventBusState[topic] || getInitialTopicState();
    eventBusState[topic].observers.push({ callback, predicate });
    if (eventBusState[topic].payload
        && (!options || options.ignorePreviousMessages !== true)) {
        callback(eventBusState[topic].payload);
    }
    // eslint-disable-next-line no-return-assign
    return () => (eventBusState[topic].observers = eventBusState[topic].observers.filter((observer) => 
    // eslint-disable-next-line implicit-arrow-linebreak
    observer.callback !== callback && observer.predicate !== predicate));
};
exports.subscribe = subscribe;
//# sourceMappingURL=event-bus.js.map